<div #body class="detail-page__body">
  <app-quick-nav #quicknav class="detail-page__nav" [toc]="toc"></app-quick-nav>
  <app-not-approved-header [notApproved]="isNotApproved"></app-not-approved-header>
  <div class="business-detail__before-overview" *ngIf="isBusinessOwner || (isRegionalManager && isFbo)">
    <div class="business-detail__edit-toggle">
      <app-edit-toggle *ngIf="isBusinessOwner || (isRegionalManager && isFbo)" class="editSlider"></app-edit-toggle>
      <div class="business-detail__edit-help" *ngIf="isBusinessOwner || (isRegionalManager && isFbo)" (click)="showHelp()">Edit Mode Help</div>
    </div>

    <app-flight-deck-button class="business-detail__flight-deck-button" (businessChange)="onReloadBusiness()"
                            *ngIf="editModeSet && (isFlightDeckAdmin || isRegionalManager)" [business]="business"></app-flight-deck-button>
    <!-- <div class="business-detail__right-text"> </div> -->
  </div>

  <div class="detail-page__content">
    <div class="detail-page__primary">
      <div id="overview" class="detail-page__wrapper scroll-spy-section">
        <div class="business-detail__left-column">
          <app-business-overview [business]="business"></app-business-overview>
        </div>
      </div>
      <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="728" [height]="90" [position]="5"></app-open-x-adunit>

      <div class="detail-page__main">
        <div id="hours" class="detail-page__wrapper scroll-spy-section">
              <app-hours [business]="business"></app-hours>
        </div>

        <div id="contacts" class="detail-page__wrapper scroll-spy-section">
          <app-contact [business]="business"></app-contact>
        </div>

        <div id="description" class="detail-page__wrapper scroll-spy-section">
          <app-business-description [business]="business"></app-business-description>
        </div>

        <div id="communication" class="detail-page__wrapper scroll-spy-section">
          <app-communication [business]="business"></app-communication>
        </div>

        <div id="fuel" class="detail-page__wrapper scroll-spy-section">
          <app-business-fuel [business]="business"></app-business-fuel>
        </div>

        <div id="fuel-providers" class="detail-page__wrapper scroll-spy-section">
          <app-fuel-providers [business]="business"></app-fuel-providers>
        </div>

        <div id="fees" class="detail-page__wrapper scroll-spy-section">
          <app-fees-section [business]="business"></app-fees-section>
        </div>

        <div id="services" class="detail-page__wrapper scroll-spy-section">
          <app-business-amenities [business]="business"></app-business-amenities>
        </div>

        <div id="rental-agency" class="detail-page__wrapper scroll-spy-section">
          <app-rental-cars [business]="business"></app-rental-cars>
        </div>

        <div id="sales" class="detail-page__wrapper scroll-spy-section">
          <app-business-sales [business]="business"></app-business-sales>
        </div>

        <div id="maintenance" class="detail-page__wrapper scroll-spy-section">
          <app-business-maintenance [business]="business"></app-business-maintenance>
        </div>

        <div id="rentals" class="detail-page__wrapper scroll-spy-section">
          <app-rentals [business]="business"></app-rentals>
        </div>

        <div id="edu" class="detail-page__wrapper scroll-spy-section">
          <app-educational-info [business]="business"></app-educational-info>
        </div>

        <div id="training" class="detail-page__wrapper scroll-spy-section">
          <app-training [business]="business"></app-training>
        </div>

        <div id="webcams" class="detail-page__wrapper scroll-spy-section">
          <app-business-webcams [business]="business"></app-business-webcams>
        </div>
      </div>
    </div>
    <div class="detail-page__rail">
      <app-associated-airports [business]="business"></app-associated-airports>

      <div class ="business-detail__section-spacer" *ngIf="isFlightSchool"></div>
      <ng-container *ngIf="!!isDoneInit">
        <app-awards-and-recognitions *ngIf="isFlightSchool" [awardTags]="this.awardTags" [displayHistoricalBadges]="this.displayHistoricalBadges"
        [displayReportCard]="this.displayReportCard" [businessId]="this.business.id.toString()" [fteAwardYear]="this.business.fteAwardYear"></app-awards-and-recognitions>
      </ng-container>

      <div class ="business-detail__section-spacer"></div>

      <div class="detail-page__rail-content">
        <div class="section__right-rail">
          <div class="section__header">
            <h2 class="section__header-text">Business Reviews</h2>
          </div>
          <div class="section__body">
            <app-reviews [airport]=null [business]="business" (reloadThisEntity)="onReloadBusiness()"></app-reviews>
          </div>
        </div>
      </div>

      <app-travel-articles [airportIdent]="faaIdent"></app-travel-articles>

      <app-flightbridge-right-rail *ngIf="isFbo" [airportIdent]="faaIdent"></app-flightbridge-right-rail>

    </div>
  </div>
</div>
